import React from 'react';

const Footer = () => {
    const footerStyle = {
        backgroundColor: '#FF9A00',
        color: 'black',
        textAlign: 'center',
        padding: '1rem',
        position: 'static',
        bottom: 0,
        width: '100%',
        boxSizing: 'border-box',  // Ensure padding is included in the width calculation
        overflowX: 'hidden',  // Prevent any horizontal overflow
    };

    return (
        <footer style={footerStyle}>
            <p style={{ margin: 0 }}>&copy; 2024 POWER GAMES. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
